import { environment } from "../environment";

export interface EnvironmentType {
  isCommercial: boolean;
  isH2F: boolean;
  isIl2: boolean;
  isGov: boolean;
}

/** Build-time helpers (not React hooks). Safe to call from module scope. */
export const getEnvironmentType = (): EnvironmentType => {
  const envType = environment.VITE_ENV_TYPE;
  const isH2F = envType === "h2f";
  const isIl2 = envType === "il2";
  const isGov = isH2F || isIl2;

  return {
    isCommercial: envType === "commercial",
    isH2F,
    isIl2,
    isGov,
  };
};

export const useEnvironmentType = (): EnvironmentType => getEnvironmentType();
